import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { del, get, set } from 'idb-keyval';

export const persister = createAsyncStoragePersister({
  storage: {
    getItem: async (key: string) => {
      try {
        return await get(key);
      } catch (e) {
        console.error('IDB getItem failed:', e);
        return null;
      }
    },
    setItem: async (key: string, value: string) => {
      try {
        await set(key, value);
      } catch (e) {
        console.error('IDB setItem failed:', e);
      }
    },
    removeItem: async (key: string) => {
      try {
        await del(key);
      } catch (e) {
        console.error('IDB removeItem failed:', e);
      }
    },
  },
  // TODO: add cleanup for old key REACT_QUERY_OFFLINE_CACHE
  key: `REACT_QUERY_OFFLINE_CACHE_v5`,
  throttleTime: 1000,
});
